import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

// bootstrap
import Form from "react-bootstrap/Form";

// hooks
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { useHistory, useLocation, Link, Redirect } from "react-router-dom";

// custom components
import { Row, Col } from "react-bootstrap";
import SubmitButton from "../UIComponents/SubmitButton";
import SmLinkButton from "../UIComponents/smLinkButton";
import LabelledInput from "../UIComponents/LabelledInput";

// api
import { signIn } from "../../api/auth";
import { SignInSchema } from "./validations/authenticationSchema";

const SignIn = ({ setUser, user }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [credentialError, setCredentialError] = useState(false);
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };

  const { register, handleSubmit, errors, formState, setError } = useForm({
    resolver: yupResolver(SignInSchema),
  });
  const { touched } = formState;

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      data.email = data.email.toLowerCase();
      const res = await signIn(data);
      setUser(res.data);
      if (res.data.userType === "caregiver") history.replace("/patientControl");
      else history.replace(from);
    } catch (err) {
      if (err.message.includes("409")) {
        alert("You are already logged in, please refresh the page.");
        setIsLoading(false);
      } else {
        setError("email", {
          type: "badCredentials",
          message: "Email or Password is incorrect",
        });
        setError("password", {
          type: "badCredentials",
          message: "",
        });
        setCredentialError(true);
        setIsLoading(false);
      }
    }
  };

  if (user) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  return (
    <>
      <Row className="d-flex justify-content-center">
        <Col xs={10} md={6}>
          <Form
            autoComplete="on"
            method="POST"
            className="mt-2"
            style={{ margin: "0 auto" }}
            onSubmit={handleSubmit(onSubmit)}
          >
            <LabelledInput
              labelAs="h6"
              label={t("signin.email")}
              name="email"
              type="email"
              autoComplete="email"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <LabelledInput
              labelAs="h6"
              label={t("signin.password")}
              name="password"
              type="password"
              autoComplete="current-password"
              inputRef={register}
              errors={errors}
              touched={touched}
            />
            <SubmitButton disabled={isLoading} className="w-100" type="submit">
              {t("signin.login")}
            </SubmitButton>
            <Form.Row>
              {credentialError ? (
                <div>
                  <div style={{ marginBottom: "15px" }}>
                    {t("signin.wrong_credentials")}
                  </div>
                  <div>
                    {t("signin.forgot_password")}
                    <SmLinkButton>
                      <Link to="/forgotPassword">{t("signin.here")}</Link>
                    </SmLinkButton>
                  </div>
                  <div>
                    {t("signin.new_user")}
                    <SmLinkButton>
                      <Link to="/register">{t("signin.here")}</Link>
                    </SmLinkButton>
                  </div>
                </div>
              ) : (
                <Link to="/register">{t("signin.no_account")}</Link>
              )}
            </Form.Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default SignIn;